import type { LanguageCode } from "./language-codes";
import { useTranslation } from "react-i18next";
import { LanguageCommandItem } from "./LanguageCommandItem";
import { languageCodes, pinnedLanguageCodes } from "./language-codes";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandList,
} from "@acdc2/ui/components/command";

type Props = {
  value?: LanguageCode;
  onSelect: (code: LanguageCode) => void;
};

export function LanguageCommand({ value, onSelect }: Props) {
  const { t } = useTranslation();

  return (
    <Command>
      <CommandInput placeholder={t("LanguageCommand.input")} />
      <CommandList>
        <CommandEmpty>{t("LanguageCommand.empty")}</CommandEmpty>
        <CommandGroup heading={t("LanguageCommand.groups.pinned")}>
          {pinnedLanguageCodes.map((code) => (
            <LanguageCommandItem
              key={code}
              name={t(`LanguageCommand.labels.${code}`)}
              code={code}
              selected={code === value}
              onSelect={() => onSelect(code)}
            />
          ))}
        </CommandGroup>
        <CommandGroup heading={t("LanguageCommand.groups.all")}>
          {languageCodes.map((code) => (
            <LanguageCommandItem
              key={code}
              name={t(`LanguageCommand.labels.${code}`)}
              code={code}
              selected={code === value}
              onSelect={() => onSelect(code)}
            />
          ))}
        </CommandGroup>
      </CommandList>
    </Command>
  );
}
